import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Female = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="female icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C13.6569 6 15 4.65685 15 3C15 1.34315 13.6569 0 12 0C10.3431 0 9 1.34315 9 3C9 4.65685 10.3431 6 12 6ZM10.3427 7C9.53059 7 8.7991 7.49109 8.49161 8.24274L5.51944 15.508C5.03296 16.6972 5.9076 18 7.19243 18C8.19072 18 9 18.8093 9 19.8076V22C9 23.1046 9.89543 24 11 24H13C14.1046 24 15 23.1046 15 22V19.8076C15 18.8093 15.8093 18 16.8076 18C18.0924 18 18.967 16.6972 18.4806 15.508L15.5084 8.24273C15.2009 7.49108 14.4694 7 13.6573 7H10.3427Z"
    />
  </svg>
)
